export class LocalStorageService {
  public readItem<T>(key: string): T | null {
    try {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    } catch (error) {
      console.error(`Error reading from localStorage: ${key}`, error);
      return null;
    }
  }

  public readRawItem(key: string): string | null {
    try {
      const item = localStorage.getItem(key);
      return item || null;
    } catch (error) {
      console.error(`Error reading from localStorage: ${key}`, error);
      return null;
    }
  }

  public writeItem<T>(key: string, value: T): void {
    try {
      const formattedValue =
        typeof value === 'string' ? value : JSON.stringify(value);
      localStorage.setItem(key, formattedValue);
    } catch (error) {
      console.error(`Error writing to localStorage: ${key}`, error);
    }
  }

  public removeItem(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error(`Error removing from localStorage: ${key}`, error);
    }
  }
}
